import { useGraphQLQuery } from '@betterment/graphql';
import { useAutoNavigate } from '@betterment/js-runtime';
import { ErrorBoundary, WorkflowLayout } from '@betterment/shared-components';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { iconDisplayForSecurity } from '@betterment/shared-components/src/utils/accountSecurityHelpers';

import { AccountCustomPortfolioDocument } from './graphql/accountCustomPortfolio.generated';
import { toCustomPortfolio } from './graphql/adapters';

import { urlBuilder } from '../Shared/urlBuilder';

export const CustomPortfolioBuilderPage = () => {
  const accountId = useRequiredParam('accountId');

  const { data } = useGraphQLQuery(AccountCustomPortfolioDocument, {
    variables: { id: accountId },
    throwOnError: true,
  });

  const navigate = useAutoNavigate();

  const handleBack = () => void navigate(urlBuilder.appAccount.absolute({ accountId }));
  const handleClose = () => void navigate(urlBuilder.appAccount.absolute({ accountId }));

  const portfolio = data ? toCustomPortfolio(data.envelopeAccount) : null;

  return (
    <ErrorBoundary fallbackType="full" feature="performance_page" owner="investing_experience">
      <WorkflowLayout pageTitle="Custom Portfolio">
        <WorkflowLayout.Header onBack={handleBack} onClose={handleClose} workflowTitle="Custom Portfolio" />
        <WorkflowLayout.Content size="full">
          {portfolio && (
            <div>
              <h1>{portfolio.name}</h1>
              <table>
                <thead>
                  <tr>
                    <th>Icon</th>
                    <th>Ticker</th>
                    <th>Name</th>
                    <th>Target Weight</th>
                  </tr>
                </thead>
                <tbody>
                  {portfolio.securityGroupAllocations.map(allocation => {
                    const { primarySecurity } = allocation.securityGroup;
                    return (
                      <tr key={primarySecurity.id}>
                        <td>
                          {iconDisplayForSecurity({ symbol: primarySecurity.symbol, logo: primarySecurity.logo })}
                        </td>
                        <td>{primarySecurity.symbol}</td>
                        <td>{primarySecurity.name}</td>
                        <td>{allocation.targetWeight.toFixed(1)}%</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </WorkflowLayout.Content>
      </WorkflowLayout>
    </ErrorBoundary>
  );
};
